import { createSlice } from "@reduxjs/toolkit";

if (localStorage.getItem("userRole") === "client") {
  ["token", "vendorId", "branchId", "userRole", "userData"].forEach(
    (element) => {
      localStorage.removeItem(element);
    }
  );
}

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("token"),
    vendorId: localStorage.getItem("vendorId"),
    branchId: localStorage.getItem("branchId"),
    userRole: localStorage.getItem("userRole"),
    userData: JSON.parse(localStorage.getItem("userData")),
  },
  reducers: {
    login(state, action) {
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("vendorId", action.payload.vendorId);
      localStorage.setItem("branchId", action.payload.branchId);
      localStorage.setItem("userRole", action.payload.userRole);
      localStorage.setItem("userData", JSON.stringify(action.payload.userData));

      state.token = localStorage.getItem("token");
      state.vendorId = localStorage.getItem("vendorId");
      state.branchId = localStorage.getItem("branchId");
      state.userRole = localStorage.getItem("userRole");
      state.userData = JSON.parse(localStorage.getItem("userData"));
    },

    logout(state) {
      state.token = localStorage.getItem("token");
      state.vendorId = localStorage.getItem("vendorId");
      state.branchId = localStorage.getItem("branchId");
      state.userRole = localStorage.getItem("userRole");
      state.userData = localStorage.getItem("userData");
    },

    update(state, action) {
      localStorage.setItem("userData", JSON.stringify(action.payload.userData));
      state.userData = JSON.parse(localStorage.getItem("userData"));
    },
  },
});

export const authActions = authSlice.actions;
export const selectAuth = (state) => state.auth;

export default authSlice.reducer;
